import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import storage from 'helpers/storage';
import { Button } from 'semantic-ui-react';
import { BillInfo, BillItems } from 'components/Bill';
import RejectModal from 'components/Bill/Modal/RejectModal';
import BillDetModal from 'components/Bill/Modal/BillDetModal';
import ReissueModal from 'components/Bill/Modal/ReissueModal';

const propTypes = {
  billDtl: PropTypes.object,
  billDtlIndex: PropTypes.number,
  modalFn: PropTypes.object.isRequired,
  onOpenModal: PropTypes.func.isRequired
};

const defaultProps = {
  billDtl: null,
  billDtlIndex: 0
};

class BillGroupDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reissueModalOpen: false,
      reissueTypeValue: 'setting'
    };
  }

  handleClick = (e) => {
    const { name } = e.target;
    const { onOpenModal } = this.props;
    onOpenModal(name, null);
  };

  reissueTypeHandle = (e, { value }) => {
    this.setState({
      reissueTypeValue: value
    });
  };

  reissueModalClose = (e) => {
    this.setState({
      reissueModalOpen: false,
      reissueTypeValue: 'setting'
    });
  };

  reissueHandle = (invoiceIdx) => {
    this.setState({
      reissueModalOpen: true,
      invoiceIdx: invoiceIdx
    });
  };
  reissueOkHandle = () => {
    const { invoiceIdx, reissueTypeValue } = this.state;
    if (!invoiceIdx) return;
    this.props.billReturn(invoiceIdx, reissueTypeValue);
    this.reissueModalClose();
  };

  render() {
    const company = storage.get('company');
    const { reissueModalOpen, reissueTypeValue } = this.state;
    const {
      billDtl,
      billDtlIndex,
      modalFn,
      onOpenModal,
      billRejected,
      billParentRejected,
      billAccepted,
      billDetListSel,
      billDetTotalSel,
      groupAdminBtn,
      billReturn
    } = this.props;
    let invoiceArray = [];
    let detail = null;
    let approval = [];
    let items = null;
    let salesSum = 0;
    let companySum = 0;
    let invoiceIdx = null;
    let isParentGroup = null;
    let parentApproval = {};
    let detailApprovalStatus = '';
    let pApprovalStatus = '';
    if (billDtl && billDtl.data && billDtl.data.invoices.length > 0) {
      const { invoices, parentApprovalStatus } = billDtl.data;
      const invoice = invoices[billDtlIndex];
      pApprovalStatus = parentApprovalStatus;
      invoiceArray = billDtl.data.invoices;
      if (invoice.usageHistoryTotal) {
        const { usageHistoryTotal } = invoice;
        items = usageHistoryTotal;
        salesSum = usageHistoryTotal.totalSales;
        companySum = usageHistoryTotal.totalPrice;
      }

      invoice.approval.forEach((item) => {
        approval.push(item);
      });

      detail = invoice.detail;
      invoiceIdx = detail.invoiceIdx;
      parentApproval = detail.parentApproval;
      isParentGroup = parentApproval.isParentGroup;
      detailApprovalStatus = detail.approvalStatus;
    }
    return (
      <StyledContainer>
        <StyledHeader className="title-invoice">청구서 상세정보</StyledHeader>
        <StyledContent>
          {detail ? (
            <BillInfo
              invoices={invoiceArray}
              detail={detail}
              approval={approval}
              salesSum={salesSum}
              companySum={companySum}
              billRejected={billRejected}
              billParentRejected={billParentRejected}
              billAccepted={billAccepted}
              onOpenModal={onOpenModal}
              items={items}
              modalFn={modalFn.btnName !== 'REJECT LIST BUTTON' ? modalFn : null}
              billDtlIndex={billDtlIndex}
            />
          ) : null}
          <BillItems
            items={items}
            salesSum={salesSum}
            companySum={companySum}
            billDetListSel={billDetListSel}
            billDetTotalSel={billDetTotalSel}
            onOpenModal={onOpenModal}
            invoiceIdx={invoiceIdx}
            isButtonView
          />
        </StyledContent>
        <StyledSubText>* 청구서 변경은 식권대장으로 연락주세요.1644 - 5047</StyledSubText>
        {modalFn && modalFn.btnName === 'BILL_DET' ? (
          <BillDetModal modalFn={modalFn} invoiceIdx={invoiceIdx} detail={detail} billDetListSel={billDetListSel} />
        ) : null}
        <ButtonGroup>
          <div style={{ display: 'inline-flex', background: '#ffffff' }}>
            {isParentGroup &&
            pApprovalStatus &&
            pApprovalStatus !== 'ACCEPTED' &&
            detailApprovalStatus !== 'REJECTED' ? (
              <ReturnButton
                color="red"
                inverted
                content="반려"
                detail={detail}
                onClick={(e) => onOpenModal('PARENT REJECT BUTTON')}
              />
            ) : null}
            {company.user.level === 99 && detailApprovalStatus === 'REJECTED' ? (
              <StyledButton color="black" inverted content="재발행" onClick={(e) => this.reissueHandle(invoiceIdx)} />
            ) : null}
            {invoiceArray.length > 1 ? (
              <div>
                <StyledButton
                  color="black"
                  inverted
                  content="폐기된 청구서 보기"
                  onClick={(e) => onOpenModal('REJECT LIST BUTTON')}
                />
                {modalFn && modalFn.btnName === 'REJECT LIST BUTTON' ? (
                  <RejectModal
                    billDtl={billDtl}
                    billDtlIndex={billDtlIndex}
                    salesSum={salesSum}
                    companySum={companySum}
                    modalFn={modalFn}
                  />
                ) : null}
              </div>
            ) : null}
          </div>
        </ButtonGroup>
        <ReissueModal
          open={reissueModalOpen}
          close={this.reissueModalClose}
          value={reissueTypeValue}
          handleChange={this.reissueTypeHandle}
          handleSuccess={this.reissueOkHandle}
        />
      </StyledContainer>
    );
  }
}

BillGroupDetail.propTypes = propTypes;
BillGroupDetail.defaultProps = defaultProps;

const StyledContainer = styled.div`
  padding: 0;
  margin-bottom: 50px;
  border: solid 1px #dcdcdc;
  border-top: 0 none;
`;

const StyledHeader = styled.h3`
  background-color: #f8f8f8;
  padding: 10px;
  max-height: 40px;
  border-top: solid 1px #dcdcdc;
  border-bottom: solid 1px #dcdcdc;
  font-size: 14px;
  border-radius: 0;
  margin-bottom: 0;
`;

const ButtonGroup = styled.div`
  position: absolute;
  padding-right: 20px;
  top: 55px;
  display: block;
  width: 100%;
  text-align: right;
`;

const StyledContent = styled.section`
  height: 100vh;
  overflow: scroll;
  padding: 1rem;
`;

const StyledButton = styled(Button)`
  &&&& {
    margin-left: 10px;
    background: #ffffff;
  }
`;

const ReturnButton = styled(Button)`
  &&&& {
    background: #ffffff;
  }
`;

const StyledSubText = styled.span`
  position: absolute;
  top: 10px;
  right: 20px;
  font-size: 14px;
  color: #000;
`;

export default BillGroupDetail;
